import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IMainState } from '../../../../interfaces';
import { popupHandleMessageFromVB } from './popupMessageReceiver';

const PopupToVBBridge = (props: { children: React.ReactNode }) => {
  const dispatch = useDispatch();
  const meeting = useSelector((state: IMainState) => state.clientState.meeting);

  const handleMessageEvent = (event: MessageEvent) => {
    popupHandleMessageFromVB(event, meeting, dispatch);
  };

  React.useEffect(() => {
    window.addEventListener('message', handleMessageEvent);
    return () => {
      window.removeEventListener('message', handleMessageEvent);
    };
  }, []);

  return <>{props.children}</>;
};

export default PopupToVBBridge;
